import blog from "../../../../../../images/projects/blog.png";
import notes from "../../../../../../images/projects/notes.png";
import oldland from "../../../../../../images/projects/oldland.png";
import ad0lphos from "../../../../../../images/projects/ad0lphos.jpg";
import cv from "../../../../../../images/projects/cv.png";
import nag from "../../../../../../images/projects/nag.png";
import terminal from "../../../../../../images/projects/terminal.png";
import insta from "../../../../../../images/projects/insta.jpg";
import qrblog from "../../../../../../images/projects/qrblog.png";
import qrnotes from "../../../../../../images/projects/qrnotes.png";
import qroldland from "../../../../../../images/projects/qroldland.png";
import qradolphos from "../../../../../../images/projects/qradolphos.png";
import qrcv from "../../../../../../images/projects/qrcv.png";
import qrnag from "../../../../../../images/projects/qrnag.png";
import qrterminal from "../../../../../../images/projects/qrterminal.png";
import qrinsta from "../../../../../../images/projects/qrinsta.png";

const ProjectList = [
  {
    tittle: [
      {
        lang: "pl",
        value: "Personal Blog",
      },
      {
        lang: "en",
        value: "Personal Blog",
      },
    ],

    addres: "blog.prabith.gq",
    qr: qrblog,
    image: blog,
    technology: [
      "react",
      "css",
      "html",
      "Javascript",
      "Gatsby",
    ],
    description: [
      {
        lang: "en",
        value:
          "Personal blog for publishing my research papers",
      },
      {
        lang: "pl",
        value:
        "Personal blog for publishing my research papers",
      },
    ],
    intresting: ["github.com/Ad0lphus/blog"],
  },
  {
    tittle: [
      {
        lang: "pl",
        value: "Writeups",
      },
      {
        lang: "en",
        value: "Writeups",
      },
    ],

    addres: "notes.prabith.gq",
    qr: qrnotes,
    image: notes,
    technology: [
      "react",
      "css",
      "html",
      "Javascript",
      "Gatsby",
    ],
    description: [
      {
        lang: "en",
        value:
          "Personal blog for publishing my writeups",
      },
      {
        lang: "pl",
        value:
        "Personal blog for publishing my writeups",
      },
    ],
    intresting: ["github.com/Ad0lphus/notes"],
  },
  {
    tittle: [
      {
        lang: "pl",
        value: "Old Landing Page",
      },
      {
        lang: "en",
        value: "Old Landing Page",
      },
    ],

    addres: "old.prabith.gq",
    qr: qroldland,
    image: oldland,
    technology: [
      "react",
      "css",
      "html",
      "Javascript",
    ],
    description: [
      {
        lang: "en",
        value:
          "Old landing page of prabith.gq",
      },
      {
        lang: "pl",
        value:
        "Old landing page of prabith.gq",
      },
    ],
    intresting: ["github.com/Ad0lphus/old-landing-page"],
  },
  //////////////////////-------------------------adolph-os
  {
    tittle: [
      {
        lang: "pl",
        value: "Ad0lph-OS",
      },
      {
        lang: "en",
        value: "Ad0lph-OS",
      },
    ],

    addres: "adolphos.prabith.gq",
    qr: qradolphos,
    image: ad0lphos,
    technology: [
      "react",
      "sass",
      "html",
      "Javascript",
    ],
    description: [
      {
        lang: "en",
        value:
          "This is a portfolio of mine which resembles the design of ubuntu-OS",
      },
      {
        lang: "pl",
        value:
        "This is a portfolio of mine which resembles the design of ubuntu-OS",
      },
    ],
    intresting: ["github.com/Ad0lphus/adolph-os"],
  },
  //////////////////////-------------------------simple viewer
  {
    tittle: [
      {
        lang: "pl",
        value: "Resume",
      },
      {
        lang: "en",
        value: "Resume",
      },
    ],

    addres: "CV.prabith.gq",
    qr: qrcv,
    image: cv,
    technology: [
      "css",
      "html",
      "Javascript"
    ],
    description: [
      {
        lang: "en",
        value:
          "My curriculum vitae",
      },
      {
        lang: "pl",
        value:
          "My curriculum vitae",
      },
    ],
    intresting: ["github.com/Ad0lphus/CV"],
  },
  //////////////////////-------------------------Nagini
  {
    tittle: [
      {
        lang: "pl",
        value: "Nagini",
      },
      {
        lang: "en",
        value: "Nagini",
      },
    ],

    addres: "nagini.prabith.gq",
    qr: qrnag,
    image: nag,
    technology: [
      "javascript",
      "css3",
      "html",
    ],
    description: [
      {
        lang: "en",
        value:
          "Illustrates the epic snake game",
      },
      {
        lang: "pl",
        value:
          "Illustrates the epic snake game.",
      },
    ],
    intresting: [],
  },
  //////////////////////-------------------------terminal
  {
    tittle: [
      {
        lang: "pl",
        value: "Ad0lphus-Terminal",
      },
      {
        lang: "en",
        value: "Ad0lphus-Terminal",
      },
    ],

    addres: "terminal.prabith.gq",
    qr: qrterminal,
    image: terminal,
    technology: [
      "javascript",
      "css3",
      "html",
    ],
    description: [
      {
        lang: "en",
        value:
          "Simple personal terminal blog",
      },
      {
        lang: "pl",
        value:
          "Simple Personal terminal blog",
      },
    ],
    intresting: [

    ],
  },
  
  //////////////////////-------------------------insta clone
  {
    tittle: [
      {
        lang: "pl",
        value: "Pen Down - Insta Clone",
      },
      {
        lang: "en",
        value: "Pen Down - Insta Clone",
      },
    ],

    addres: "insta.prabith.gq",
    qr: qrinsta,
    image: insta,
    technology: [
      "javascript",
      "css3",
      "html",
    ],
    description: [
      {
        lang: "en",
        value:
          "cloned website of instagram",
      },
      {
        lang: "pl",
        value:
          "cloned website of instagram",
      },
    ],
    intresting: [],
  },
];

export default ProjectList;
